import { render, staticRenderFns } from "./SoundsAdd.vue?vue&type=template&id=55c28c52&scoped=true&"
import script from "./SoundsAdd.vue?vue&type=script&lang=js&"
export * from "./SoundsAdd.vue?vue&type=script&lang=js&"
import style0 from "./SoundsAdd.vue?vue&type=style&index=0&id=55c28c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c28c52",
  null
  
)

export default component.exports